import { j as o } from "./kezios-design-system.esm172.js";
import { IconComponent as t } from "./kezios-design-system.esm4.js";
const c = (r) => /* @__PURE__ */ o.jsx(t, { ...r, viewBox: "0 0 25 21", stroke: "none", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M20.898.531a4.05 4.05 0 0 1 4.05 4.05v11.844a4.05 4.05 0 0 1-4.05 4.05H4.075a4.05 4.05 0 0 1-4.05-4.05V4.58A4.05 4.05 0 0 1 3.845.538l.23-.007h16.823Zm0 1.87H4.075l-.179.007A2.18 2.18 0 0 0 1.895 4.58v11.844a2.18 2.18 0 0 0 2.18 2.18h16.823a2.18 2.18 0 0 0 2.18-2.18V4.58a2.18 2.18 0 0 0-2.18-2.18ZM4.387 10.5c0-3.92 3.38-5.95 6.382-4.239a.934.934 0 1 1-.926 1.624C8.1 6.891 6.256 8 6.256 10.5c0 2.498 1.85 3.609 3.588 2.62a.934.934 0 1 1 .924 1.625C7.77 16.45 4.387 14.417 4.387 10.5Zm9.346 0c0-3.92 3.38-5.95 6.382-4.239a.934.934 0 1 1-.926 1.624c-1.742-.994-3.587.115-3.587 2.615 0 2.498 1.85 3.609 3.587 2.62a.934.934 0 1 1 .925 1.625c-2.998 1.705-6.381-.328-6.381-4.245Z"
  }
) });
export {
  c as IconSubtitles
};
